import type { Theme } from '@mui/material';
import { alpha } from '@mui/material/styles';

export const styles = {
  button: (theme: Theme) => ({
    backgroundColor: 'transparent',
    color: 'inherit',
    '&:hover': {
      backgroundColor: alpha(theme.colors.white, 0.2),
    },
  }),
};
